import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

// Shown from Submit until the report PDF is ready (or fails/has no data).
// Kept as a plain modal instead of navigating anywhere, so the user never
// sees an about:blank tab flash before the real PDF tab opens.
const ReportGeneratingModal = ({ open, text = "Generating report, please wait..." }) => {
  return (
    <Dialog open={open} disableEscapeKeyDown maxWidth="xs">
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
            py: 2,
            px: 3,
          }}
        >
          <CircularProgress />
          <Typography>{text}</Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ReportGeneratingModal;
